import type { ReactNode } from 'react';
import React from 'react';
import { styled } from 'baseui';
import { type ModalOverrides, Modal, ModalBody, ModalHeader, ROLE, SIZE } from 'baseui/modal';
type PropsT = {
  setIsModalOpen: (a: boolean) => void;
  isModalOpen?: boolean;
  children: ReactNode;
  showDivider?: boolean;
  overrides?: ModalOverrides;
};
const Divider = styled('div', ({
  $theme: {
    colors
  }
}) => ({
  height: 0,
  borderTop: `2px solid ${colors.primary200}`,
  margin: '8px 0px'
}));
const HotkeyModal = ({
  setIsModalOpen,
  isModalOpen,
  children,
  showDivider = true,
  overrides = {}
}: PropsT) => {
  return <Modal onClose={() => setIsModalOpen(false)} closeable isOpen={isModalOpen} animate autoFocus size={SIZE.default} role={ROLE.dialog} overrides={overrides}>
      <ModalHeader>Keyboard Shortcuts</ModalHeader>
      <ModalBody style={{
      height: '500px',
      overflowY: 'auto'
    }}>
        {showDivider && <Divider />}
        {children}
      </ModalBody>
    </Modal>;
};
export default HotkeyModal;